import { render, staticRenderFns } from "./BgOverlay.vue?vue&type=template&id=758f69ae&scoped=true&"
import script from "./BgOverlay.vue?vue&type=script&lang=js&"
export * from "./BgOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758f69ae",
  null
  
)

export default component.exports